import { HTTP_SUCCESS_CODE, ERROR_HTTP_CODE } from '../enum/error'

/**
 * 端口号配置
 */
export enum CONFIG {
  PORT = 3122,
}

/**
 * 站点相关配置
 */
export enum SITE {
  PORT = 3122,
  LANG = 'en_US',
  COUNTRY = 'AU',
  BASE_URL = '/au-community/',
  NAME = '',
  DESCRIPTION = '',
  KEYWORDS = '',
  TITLE = '\u200E',
}

/**
 * 验签匹配的正则
 */
export const ENCRYPTREG = new RegExp(/\/au-global-gateway/)

/**
 * 接口相关配置
 */
export enum API {
  // 开发环境
  // DOMAIN = 'http://114.116.204.69:30956/',
  // 测试环境
  // DOMAIN = 'https://ap2-h5-gateway-test.gwmcloud.com/',
  // 预生产环境
  DOMAIN = 'https://ap-h5-gateway-stage.gwmcloud.com/',
  // 生产环境
  // DOMAIN = 'https://ap-h5-gateway.gwmcloud.com/',
  PRE = '/au-global-gateway/',
  VERSION1 = 'v1.0',
  VERSION2 = 'v2.0',
}

export enum AUTH {
  // 开发环境
  // APP_KEY = '2186661209',
  // SECRET_KEY = 'a9664fd3f97665e202e73880de03a0d8',
  // 测试环境
  // APP_KEY = '9634449022',
  // SECRET_KEY = '4a1d27c9e360a879b8a3022ecca28f0a',
  // 预生产环境
  APP_KEY = '4952157517',
  SECRET_KEY = '7cabc9cc3f53f2231ffe439ea63ce1ee',
  // 生产环境
  // APP_KEY = '2186661209',
  // SECRET_KEY = 'a9664fd3f97665e202e73880de03a0d8',
}

/**
 * 站点支持的语言列表
 */
export const LOCALES = ['en_US', 'pt_BR']

/**
 * token失效，需要调用原生的 invalidToken 方法
 */
export const INVALID_TOKEN = [
  ERROR_HTTP_CODE.REPEAT_LOGIN,
  ERROR_HTTP_CODE.EX_REFRESHTOKEN_INVALID,
  ERROR_HTTP_CODE.TEMPORARY_ERROR,
]

/**
 * token为空
 */
export const NO_TOKEN = [
  ERROR_HTTP_CODE.EX_ACCESSTOKEN_EMPTY,
  ERROR_HTTP_CODE.EX_ACCESSTOKEN_EMPTY_GATEWAY,
]

/**
 * 接口请求返回的message不使用统一封装的默认Toast弹出
 */
export const ERROR_CODE_TOAST_EXCLUDE = [
  HTTP_SUCCESS_CODE,
  ERROR_HTTP_CODE.TOKEN_ERROR,
  ...NO_TOKEN,
  ...INVALID_TOKEN,
]

/** 不需要弹出异常提醒的接口url
 */
export const URL_TOAST_EXCLUDE = []

// vconsle 初始化兼容处理
export const initVconsole = () => {
  return [
    {
      src: `${SITE.BASE_URL}vconsole.min.js`,
      type: 'text/javascript',
    },
    {
      innerHTML:
        // , "aus-h5-front-stage.gwmcloud.com"
        'var env = env = ["aus-h5-front-test.gwmcloud.com"]; if (env.includes(location.host) || process.dev) {new VConsole()}',
    },
  ]
}

/**
 * 接口前缀
 */
export const gateway = 'app-api/api/v1.0'
export const gatewayV2 = 'app-api/api/v2.0'
